import { createSlice } from '@reduxjs/toolkit';

export const getUserIdSlice = createSlice({
    name: 'getUserId',
    initialState: {userId: null},
    reducers:{
        setUserId: (state,action) => {
            state.userId = action.payload 
        }
    }
}) 

export const {setUserId} =  getUserIdSlice.actions;
export default getUserIdSlice.reducer;
